// extracted by mini-css-extract-plugin
export default {"title":"experience-section_title__uCgzH","section":"experience-section_section__R8rM0","image":"experience-section_image__MJvSc"};